import { render, staticRenderFns } from "./LatestPostAreaComponent.vue?vue&type=template&id=6691e5b7&lang=pug&"
import script from "./LatestPostAreaComponent.vue?vue&type=script&lang=js&"
export * from "./LatestPostAreaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports